/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    CLOUD_BACKUP_PLANS_RECEIVE,
    CLOUD_BACKUP_PLANS_REQUEST,
    CLOUD_BACKUP_PLANS_REQUEST_SUCCESS,
    CLOUD_BACKUP_PLANS_REQUEST_FAILURE,
    CURRENT_CLOUD_BACKUP_RECEIVE,
} from 'state/action-types';

export const items = createReducer([], {
    [CLOUD_BACKUP_PLANS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, subscription) => {
                const { id } = subscription;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = subscription;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [CLOUD_BACKUP_PLANS_REQUEST]: () => true,
    [CLOUD_BACKUP_PLANS_REQUEST_SUCCESS]: () => false,
    [CLOUD_BACKUP_PLANS_REQUEST_FAILURE]: () => false,
});


export const error = createReducer(false, {
    [CLOUD_BACKUP_PLANS_REQUEST]: () => false,
    [CLOUD_BACKUP_PLANS_REQUEST_SUCCESS]: () => false,
    [CLOUD_BACKUP_PLANS_REQUEST_FAILURE]: () => true,
});


export default combineReducers({
    items,
    requesting,
    error
});
